import React, { useEffect, useRef, useState } from 'react'
import CSVDownloader from "react-csv-downloader"
import { IconDownload } from "@tabler/icons-react"
import { useOutsideClickHandler } from '../../../Utils/hooks/useOutsideClickHandler'
export const ReportTableHeader = ({
    tableTitle,
    data,
    vcolumns,
    columns,
    setColumns,
    setVColumns,
}) => {
    const [allColumns, setAllColumns] = useState([])

    const reportsFieldDropRef = useRef(null)
    const [reportsFieldFilter, setReportsFieldFilter] = useState(false)

    useEffect(() => {
        const headers = Object.keys(data[0] || {})
        const allCols = headers.map((header, index) => ({
            key: index,
            id: header,
            displayName: header
                .replace(/_/g, " ")
                .replace(/\b\w/g, (l) => l.toUpperCase()),
            mandatory:
                header === "name" ||
                    header === "sales_order" ||
                    header === "po_no" ||
                    header === "quotation_number"
                    ? true
                    : false,
        }))
        setAllColumns(allCols)
        // Set initial columns
        setColumns(allCols)
        // Set initial visible columns
        setVColumns(headers)
    }, [data])

    // State for temporary column selection (before applying)
    const [tempColumns, setTempColumns] = useState([])

    useEffect(() => {
        let filter = allColumns.filter((col) => !col?.mandatory).map((col) => col.id)
        setTempColumns(filter)
    }, [allColumns])

    const handleCheckboxChange = (col) => {
        if (col.mandatory) return

        setTempColumns((prev) => {
            if (prev.includes(col.id)) {
                return prev.filter((id) => id !== col.id)
            } else {
                const allNonMandatoryLabels = allColumns
                    .filter((opt) => !opt.mandatory)
                    .map((opt) => opt.id)

                const currentIndex = allNonMandatoryLabels.indexOf(col.id)
                const newColumns = [...prev]
                newColumns.splice(currentIndex, 0, col.id)
                return newColumns
            }
        })
    }

    const getFinalColumnOrder = () => {
        const visibleNonMandatoryColumns = tempColumns
        const finalOrder = []

        allColumns.forEach((col) => {
            if (col.mandatory) {
                finalOrder.push(col.id)
            } else if (visibleNonMandatoryColumns.includes(col.id)) {
                finalOrder.push(col.id)
            }
        })

        return finalOrder
    }
    // custom hook for outside click dropdown close
    useOutsideClickHandler({
        objRef: reportsFieldDropRef,
        isDropdown: reportsFieldFilter,
        setDropdown: setReportsFieldFilter
    })

    const handleApplyColumns = () => {
        const finalColumns = getFinalColumnOrder()
        setVColumns(finalColumns)
        setReportsFieldFilter(false)
    }

    const getCsvFileName = () => {
        const now = new Date()
        const date = now.toLocaleDateString("en-GB").split("/").join("-")
        const time = now.toLocaleTimeString("en-GB", { hour12: false })
        return `${date}_${time}`
    }
    return (
        <>
            <h5 className="fw-semibold ms-2">{tableTitle}</h5>
            {data.length > 0 && (
                <>
                    <div className="d-flex gap-3 ">
                        <CSVDownloader
                            columns={vcolumns}
                            className="download-to-csv btn btn-default"
                            style={{ height: "2.2rem", alignItems: 'center', display: 'flex' }}
                            datas={data}
                            filename={
                                tableTitle ? tableTitle + `${getCsvFileName()}` : "report"
                            }
                            separator=","
                            text={
                                <>
                                    <IconDownload stroke={2} size={18} />
                                </>
                            }
                        />
                    </div>
                </>
            )}
        </>
    )
}
